import React,{Component} from "react";
import Header from "../../components/Header";
import { Grid, TextField, Typography } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Grade';
import Fab from '@material-ui/core/Fab';
import {
    primaryColor,
    webFont
} from "../../config/theme";
import {compose, graphql} from "react-apollo/index";
import {connect} from "react-redux";
import { getChef, getChefReviewTags} from "../../redux/user";
import {SUBMIT} from "../../graphql/mutations/review"
import {NotificationManager} from "react-notifications";

class UserReview extends Component {
    state={
        review:[1,2,3,4,5],
        starReview:'',
        selectedReviewTag:[],
        message:'',
        booking:''
    };

    componentDidMount(){

        if (!this.props.location.state) {
            return this.props.history.push("/home/dashboard");
        }

        const {
            location: {
                state: { booking }
            }
        } = this.props;

        this.setState({booking});
        const { dispatch, userId } = this.props;
        dispatch(getChefReviewTags(userId));
        dispatch(getChef(userId));

    }

    handleStarReviewClick = review =>{
        let starReview=review;
        this.setState({starReview});
    }

    handleReviewClick = review =>{
        let {selectedReviewTag}=this.state;
        let index = selectedReviewTag.indexOf(review);
        if(index == -1){
            selectedReviewTag.push(review);
        }else{
            selectedReviewTag.splice(index, 1);
        }
        this.setState({selectedReviewTag});
    }

    handleMessageChange = e =>{
        let message=e.target.value;
        this.setState({message});
    }

    submitReview=()=>{

        const { submitReview,userId,chef } = this.props;
        let {starReview,selectedReviewTag,message,booking}=this.state;
        if(starReview) {
            let payload = {
                reviewer: chef.id,
                reviewerName: `${chef.firstName} ${chef.lastName}`,
                reviewType: 'USER',
                reviewee: booking.userId,
                rating: starReview,
                body: message,
                tags: selectedReviewTag,
                bookingId: booking.id
            }

            submitReview({
                variables: {
                    review: payload
                }
            })
                .then(res => {
                    NotificationManager.error("Review Submitted");
                })
                .catch(err => {
                    console.log(JSON.parse(JSON.stringify(err)));
                    let errorObj = JSON.parse(JSON.stringify(err));
                    if (errorObj.graphQLErrors) {
                        errorObj.graphQLErrors.map(error => {
                            NotificationManager.error(error.message, "Booking");
                        });
                    }
                });
        }else{
            NotificationManager.error("Review has not been given");
        }

    }

    render() {
        let {starReview,selectedReviewTag}=this.state;
        let {chefReview}=this.props;
        let customReview=[];
        let starReviews = this.state.review.map(review => {
            return (
                <div>
                    <Grid item xs={2}>
                        <Grid container  spacing={1}>
                            <Button
                                variant={starReview==review ? "contained" : "outlined"}
                                color={"primary"}
                                aria-label="Add"
                                style={starReview==review ?styles.ratingIcon : {...styles.ratingIcon,color:primaryColor}}
                                onClick={() => this.handleStarReviewClick(review)}
                            >
                                <SaveIcon style={{...styles.leftIcon, ...styles.iconSmall}} />
                                {review}
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            );
        });

        if(chefReview.length > 0) {
            customReview = chefReview.map(review => {
                return (
                    <div>
                        <Grid item xs={2}>
                            <Grid container spacing={1}>
                                <button

                                    aria-label="Add"
                                    style={!!review && selectedReviewTag.indexOf(review) == -1 ? styles.selectedReviewOutlined :  styles.selectedReview}
                                    onClick={() => this.handleReviewClick(review)}
                                >
                                    {review}
                                </button>
                            </Grid>
                        </Grid>
                    </div>
                );
            });
        }

        return (
            <div>
                <div>
                    <Header history={this.props.history} />
                </div>
                <Grid style={{
                    margin: 35
                }}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography
                                style={{
                                    ...styles.setFont,
                                    fontSize: 24,
                                    fontWeight: 600,
                                    marginBottom: 10
                                }}
                            >
                                Diner rating & review
                            </Typography>
                            <Typography
                                style={{
                                    ...styles.setFont,
                                    fontSize: 18,
                                    fontWeight: 'normal',
                                    marginBottom: 20
                                }}
                            >
                                How did you find the experience with the chef?
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container>
                        <Grid item xs={6}>
                            <Grid container>
                                {starReviews}
                            </Grid>
                        </Grid>
                        <Grid item xs={6}/>
                    </Grid>

                    <Grid container>
                        <Grid container>
                            <Grid item xs={12}>
                                <Typography
                                    style={{
                                        ...styles.setFont,
                                        fontSize: 18,
                                        fontWeight: 'normal',
                                        marginBottom: 20,
                                        marginTop: 20
                                    }}
                                >
                                    Review
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid container>
                                {customReview}
                            </Grid>
                        </Grid>
                        <Grid item xs={6}/>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6}>
                            <div
                                style={{
                                    padding: 20,
                                    opacity: 0.62,
                                    borderRadius: 2,
                                    borderWidth: 1,
                                    borderColor: "#979797"
                                }}
                            >
                                <TextField
                                    fullWidth
                                    id="outlined-with-placeholder"
                                    multiline="true"
                                    rows="3"
                                    placeholder="Tell chef about the nature and purpose of the engagement"
                                    margin="normal"
                                    variant="outlined"
                                    onChange={(e)=>{this.handleMessageChange(e)}}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={6}/>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} alignItems='center'>
                            <Fab
                                variant="extended"
                                color={primaryColor}
                                aria-label="Add"
                                style={{...styles.submitReview,textAlign:'center'}}
                                onClick={() => this.submitReview()}
                            >
                                Submit
                            </Fab>
                        </Grid>
                    </Grid>
                </Grid>
            </div>


        );
    }
}


const mapStateToProps = state => {
    return {
        userId: state.auth.userId,
        isChef: state.auth.isChef,
        chefReview: state.user.chefReview,
        diner: state.user.diner,
        chef: state.user.chef
    };
};

const UserReviewWithData = compose(
    graphql(SUBMIT, { name: "submitReview" })
)(UserReview);
const UserReviewTags = connect(mapStateToProps)(UserReviewWithData);
export default UserReviewTags;
const styles = {
    setFont: {
        fontFamily: webFont
    },
    setColor: {
        backgroundColor: primaryColor
    },
    button: {
        margin: 10,
    },
    leftIcon: {
        marginRight: 10,
    },
    rightIcon: {
        marginLeft: 10,
    },
    iconSmall: {
        fontSize: 20,
    },
    ratingIcon :{
        borderRadius: 32,
        width:56,
        height:32,
        color: 'white',
        fontFamily: webFont,
        textTransform: "none",
        margin:5,
        fontSize:14
    },
    submitReview :{
        borderRadius: 32,
        backgroundColor: primaryColor,
        height:32,
        border: "none",
        color: "white",
        fontFamily: webFont,
        textTransform: "none",
        margin:5,
        fontSize:16
    },
    selectedReview :{
        borderRadius: 40,
        backgroundColor: primaryColor,
        height:32,
        color: 'white',
        fontFamily: webFont,
        textTransform: "none",
        margin:5,
        fontSize:16,
        border:'none',
        paddingRight:10,
        paddingLeft:10,

    },
    selectedReviewOutlined :{
        borderRadius: 40,
        backgroundColor: 'white',
        height:32,
        color: primaryColor,
        fontFamily: webFont,
        textTransform: "none",
        margin:5,
        fontSize:16,
        paddingRight:10,
        paddingLeft:10,
        borderColor:primaryColor

    }

};

